import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';

import API from '../Util/api';

class Logout extends Component {
   constructor(props) {
     super(props);

     this.state = {
       redirectPath: null,
     }
   }

  logout() {
    API.get("/user/logout")
      .finally(() => {
        sessionStorage.removeItem('mfaGateChecked');
        this.setState({ redirectPath: "/login" });
      });
  }

  componentDidMount() {
    this.logout();
  }

  render() {
    if (this.state.redirectPath) {
      return (
        <Redirect to={this.state.redirectPath} />
      );
    }

    return (
      <div></div>
    );
  }
}

export default Logout;
